import React, { useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import classnames from "classnames";
import useLeagueSeason from "../../hooks/queryResults/useLeagueSeason";
import Util from "../../util/util";
import Loading from "../ui/Loading";
import MessagePostForm from "./MessagePostForm";
import MessageThread from "./MessageThread";
import Box from "../layout/Box";
import Pagination from "../ui/Pagination";
import useMessageBoard from "../../hooks/queryResults/useMessageBoard";

export default function MessageBoard() {
  const { leagueSeason, leagueQuery } = useLeagueSeason();
  const location = useLocation();
  const history = useHistory();
  let { pageNum } = useParams();
  if (!pageNum) pageNum = 1;
  pageNum = parseInt("" + pageNum, 10);

  const [showNewPostButton, setShowNewPostButton] = useState(true);
  const [hideNewPostForm, setHideNewPostForm] = useState(true);

  const limit = 10;
  const { messages, messageBoardQuery } = useMessageBoard(pageNum, limit);

  const handlePageChange = (page) => {
    const pattern = /\/page\/(\d+)/;
    const pathname = pattern.test(location.pathname)
      ? location.pathname.replace(pattern, `/page/${page}`)
      : location.pathname + `/page/${page}`;

    history.push(pathname);
  };

  const handleShowForm = () => {
    setShowNewPostButton(false);
    setHideNewPostForm(false);
  };

  const handleHideForm = () => {
    setShowNewPostButton(true);
    setHideNewPostForm(true);
  };

  let loading = false;
  if (
    leagueQuery.isLoading ||
    !leagueSeason ||
    messageBoardQuery.isLoading ||
    !messages
  )
    loading = true;

  const currentSeason = Util.getCurrentSeason();
  const isCurrentSeason =
    leagueSeason && leagueSeason.obj.season === currentSeason;

  return (
    <Box title={"message board"}>
      <div
        style={{
          color: "black",
          width: "100%",
        }}
      >
        {/*<div*/}
        {/*  style={{*/}
        {/*    display: "flex",*/}
        {/*    justifyContent: "space-between",*/}
        {/*    alignItems: "center",*/}
        {/*    marginBottom: "1rem",*/}
        {/*  }}*/}
        {/*>*/}
        {showNewPostButton && isCurrentSeason && (
          <div>
            <button
              onClick={handleShowForm}
              className={classnames("btn", "btn-secondary")}
              style={{ marginBottom: "1rem" }}
            >
              Add New Post
            </button>
          </div>
        )}
        {/*todo: implement search*/}
        {/*<div>*/}
        {/*  <input*/}
        {/*    type={"text"}*/}
        {/*    style={{*/}
        {/*      margin: "0",*/}
        {/*      border: "none",*/}
        {/*      height: "1.875rem",*/}
        {/*    }}*/}
        {/*    className={classnames("left")}*/}
        {/*  />*/}
        {/*  <button className={classnames("btn", "btn-secondary", "btn-right")}>*/}
        {/*    Search*/}
        {/*  </button>*/}
        {/*</div>*/}
        {/*</div>*/}
        {!hideNewPostForm && isCurrentSeason && (
          <MessagePostForm
            handleHideForm={handleHideForm}
            isReply={false}
            replyToMessageId={""}
          />
        )}
        {loading ? (
          <Loading />
        ) : messages.items.length === 0 ? (
          <h2 style={{ color: "white" }}>No messages yet.</h2>
        ) : (
          messages.items.map((message, i) => {
            return (
              <MessageThread
                key={i}
                message={message}
                replies={messages.getReplies(message.obj.id)}
              />
            );
          })
        )}
      </div>
      {!loading && (
        <Pagination
          className="pagination-bar"
          currentPage={pageNum}
          totalCount={messageBoardQuery.data.total}
          pageSize={limit}
          onPageChange={(page) => handlePageChange(page)}
        />
      )}
    </Box>
  );
}
